import { MortgageCalculator, MortgageCalculatorProps } from './MortgageCalculator';
import withEvents from 'analytics/withEvents';

import { BANNER_ID, BANNER_LINK } from './constants';

export default withEvents<MortgageCalculatorProps>(sendEvent => {
  const eventData = {
    banner_id: BANNER_ID,
    banner_is_external: true,
    banner_url: BANNER_LINK,
    banner_index: 0,
  };
  return ({
    onBannerClick() {
      sendEvent('banner_click', 'banner', {
        event: { ...eventData },
      });
    },
    bannerExpose() {
      sendEvent('banner_exposed', 'banner', {
        event: { ...eventData },
      });
    },
  });
})(MortgageCalculator);
